'use strict';

module.exports = require('../services/createErrorClass')({
	name: 'UserHasFamilyError',
	message:
		'You cannot link that user because they are already the billing user of a family account.',
	soft: true
});
